import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-white" data-id="element-109" data-mp="1o3dmwcdeadr5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-110" data-mp="2223jzs07sdfi">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-teal bg-teal-soft text-ink" data-id="element-111" data-mp="1x3tk543joonk">
          <span className="font-display text-4xl font-bold leading-none" data-id="element-112" data-mp="19f0mn379y8qu">7</span>
          <span className="font-sans text-[10px] font-bold uppercase tracking-widest" data-id="element-113" data-mp="14gz88vksmxlp">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-114" data-mp="1j654qbs8y9pw">Zero risk</p>
        <h2 id="guarantee-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-115" data-mp="1ebr2bpf632bq">
          Teach your next class from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-slate" data-id="element-116" data-mp="lo528r55eftm">
          Open the volume for your apparatus and run Class 1 with your group, as
          written. Use the Placement Drill on your next new student and The Flight
          Plan to map your term. If Aerial Class Ready doesn&apos;t make your
          classes easier to plan and run, email us inside 7 days and you get every
          cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-117" data-mp="12q4wqfcu5wq7">
          {chips.map(chip => <li key={chip} className="rounded-full border border-cloud-dark px-4 py-2 text-[13px] text-slate" data-id="element-118" data-mp="62i833m07inb">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}